import script from "./SelectStaff.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectStaff.vue?vue&type=script&setup=true&lang=js"

import "./SelectStaff.vue?vue&type=style&index=0&id=6db75f9b&scoped=true&lang=css"

import exportComponent from "/srv/http/navreme-stage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6db75f9b"]])

export default __exports__